import { Link } from "react-router-dom";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { SignedAvatarImage } from "@/components/signed-avatar-image";
import { useUser } from "@/hooks/users";
import type { Prd } from "@/types/domain";

// PRD rows carry ownerId only; the person comes from the /users directory.
const OwnerCell = ({ prd }: { prd: Prd }) => {
  const owner = useUser(prd?.ownerId);

  // Keep the fixed column even without an owner — dropping it shifts the
  // date/action columns and rows stop lining up.
  if (!prd || !owner)
    return (
      <span
        title="No owner"
        className="shrink-0 text-xs text-muted-foreground md:w-18"
      >
        —
      </span>
    );

  return (
    <Link
      to={`/users/${owner.id}/prds`}
      // Fixed column so names start at the same x across rows (left-aligned,
      // owner 2026-10-22); 72px fits a 3-char CJK name, longer ones truncate.
      // Phones keep the avatar only.
      className="flex shrink-0 items-center gap-2 hover:text-primary md:w-18"
      title={owner.name}
    >
      {owner.avatarThumb && (
        <Avatar className="h-6 w-6">
          <SignedAvatarImage src={owner.avatarThumb} alt={owner.name} />
          <AvatarFallback className="text-xs">{owner.name?.[0]}</AvatarFallback>
        </Avatar>
      )}
      <span className="hidden min-w-0 truncate text-xs md:inline">
        {owner.name}
      </span>
    </Link>
  );
};

export default OwnerCell;
